(function () {
  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function cleanValue(value) {
    return String(Math.round(value));
  }

  function getCurrentPath() {
    return window.location.pathname;
  }

  function initPriceSlider(root) {
    if (root.dataset.lgPriceSliderInitialized === 'true') {
      return;
    }

    var rangeMin = toNumber(root.dataset.min, 0);
    var rangeMax = toNumber(root.dataset.max, 0);
    var step = toNumber(root.dataset.step, 1);

    var minHidden = root.querySelector('[data-price-min-hidden]');
    var maxHidden = root.querySelector('[data-price-max-hidden]');

    var minField = root.querySelector('[data-price-min-field]');
    var maxField = root.querySelector('[data-price-max-field]');

    var minRange = root.querySelector('[data-price-min-range]');
    var maxRange = root.querySelector('[data-price-max-range]');

    var applyTimer = null;

    if (!minHidden || !maxHidden || !minField || !maxField || !minRange || !maxRange || !rangeMax) {
      return;
    }

    root.dataset.lgPriceSliderInitialized = 'true';

    function setActive(input) {
      minRange.classList.remove('is-active');
      maxRange.classList.remove('is-active');
      input.classList.add('is-active');
    }

    function sync(source) {
      var minValue = toNumber(minRange.value, rangeMin);
      var maxValue = toNumber(maxRange.value, rangeMax);

      if (source === minRange || source === minField) {
        minValue = toNumber(source.value, minValue);
        minValue = clamp(minValue, rangeMin, maxValue);
      }

      if (source === maxRange || source === maxField) {
        maxValue = toNumber(source.value, maxValue);
        maxValue = clamp(maxValue, minValue, rangeMax);
      }

      minValue = Math.round(minValue / step) * step;
      maxValue = Math.round(maxValue / step) * step;

      minRange.value = cleanValue(minValue);
      maxRange.value = cleanValue(maxValue);
      minField.value = cleanValue(minValue);
      maxField.value = cleanValue(maxValue);

      minHidden.value = minValue > rangeMin ? cleanValue(minValue) : '';
      maxHidden.value = maxValue < rangeMax ? cleanValue(maxValue) : '';

      var minPercent = ((minValue - rangeMin) / (rangeMax - rangeMin)) * 100;
      var maxPercent = ((maxValue - rangeMin) / (rangeMax - rangeMin)) * 100;

      root.style.setProperty('--min-percent', minPercent + '%');
      root.style.setProperty('--max-percent', maxPercent + '%');
    }

    function getFilteredUrl() {
      var form = root.closest('[data-faceted-filter-form]') || root.closest('form');

      if (!form) {
        return null;
      }

      var formData = new FormData(form);
      var params = new URLSearchParams();

      formData.forEach(function (value, key) {
        if (value !== '') {
          params.append(key, value);
        }
      });

      var sortByEl = document.querySelector('[data-sort-by]');

      if (sortByEl && sortByEl.value) {
        params.set('sort_by', sortByEl.value);
      }

      params.delete('page');

      var queryString = params.toString();

      /*
        Important:
        Use the current path, not only the base collection URL.
        This preserves custom tag URLs such as:
        /collections/couches/full-suite
      */
      var baseUrl = getCurrentPath();

      return queryString ? baseUrl + '?' + queryString : baseUrl;
    }

    function applyPriceFilter(delay) {
      window.clearTimeout(applyTimer);

      applyTimer = window.setTimeout(function () {
        var nextUrl = getFilteredUrl();

        if (!nextUrl) {
          return;
        }

        var currentUrl = window.location.pathname + window.location.search;

        if (nextUrl === currentUrl) {
          return;
        }

        if (window.quickFilter && typeof window.quickFilter.updateView === 'function') {
          window.quickFilter.updateView(nextUrl);
        } else {
          window.location.href = nextUrl;
        }
      }, delay || 0);
    }

    [minRange, maxRange].forEach(function (input) {
      input.addEventListener('pointerdown', function () {
        setActive(input);
      });

      input.addEventListener('focus', function () {
        setActive(input);
      });

      input.addEventListener('input', function () {
        setActive(input);
        sync(input);
      });

      input.addEventListener('change', function () {
        sync(input);
        applyPriceFilter(150);
      });
    });

    [minField, maxField].forEach(function (input) {
      input.addEventListener('focus', function () {
        if (input === minField) {
          setActive(minRange);
        } else {
          setActive(maxRange);
        }
      });

      input.addEventListener('input', function () {
        sync(input);
        applyPriceFilter(900);
      });

      input.addEventListener('change', function () {
        sync(input);
        applyPriceFilter(150);
      });
    });

    sync();
  }

  function initAllPriceSliders() {
    document.querySelectorAll('[data-lg-price-slider]').forEach(initPriceSlider);
  }

  window.LGPriceSlider = window.LGPriceSlider || {};
  window.LGPriceSlider.init = initAllPriceSliders;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPriceSliders);
  } else {
    initAllPriceSliders();
  }

  document.addEventListener('shopify:section:load', initAllPriceSliders);
})();